import React from "react";
import * as actions from '../Actions';
import Service from '../../service/Service';
const service = new Service();
import { Link } from "react-router-dom";
import ShareOptions from './ShareOptions';

export default function QuickLinks({ quickread, eleRef, title }) {
    return (
        <div className="quickread-links">
            <span className={quickread.isMyLike == 1 ? "quickread_social_actions cursor-pointer M13_422 likeCmtIcon is-active" : "quickread_social_actions cursor-pointer M13_422 likeCmtIcon"} onClick={() => actions.quickreadLike(quickread.discussionId, quickread.userId, quickread.groupId, quickread.categoryId, quickread.isMyLike == 1 ? 0 : 1, eleRef, title,3)}>
                {quickread.isMyLike == 1 ?
                <span data-icon-font="&#xe021;" className="icon like-cmnt"></span>
                :
                <span data-icon-font="&#xe009;" className="icon like-cmnt"></span>
                }
                <span className="social_action_names dev_like">Like</span>
            </span>
                       
            <span className={quickread.isMyComment == 1 ? "M13_422 quickread_social_actions openParticipate is-active" : "M13_422 quickread_social_actions openParticipate"} onClick={() => actions.openParticipatePopup(quickread.discussionId, quickread.title, quickread.discription, quickread.groupId, quickread.categoryId, quickread.urls && quickread.urls[0] ? quickread.urls[0].source : '')}>
                <div data-icon-font="&#xe01d;" className="icon dev_comment"></div>
                <span className="dev_comment">Comment</span>
            </span>
            
            <span className="M13_422 quickread_social_actions card-share" id={`share_${quickread.discussionId}`}>
                <div className="share-container" onClick={() => actions.shareOn(quickread.discussionId)}>
                    <div data-icon-font="&#xe027;" className="icon share-icon"></div>
                    <span className="share-text">Share</span>
                </div>
                <ShareOptions quickread={quickread} eleRef={this} />
            </span>

            <div className="quickactionLike">
                <span className="quickread_followers actioncount dev_like" data-count={quickread.likeCount}>
                    <span className="L10_63 quickread_followers">{service.intToString(quickread.likeCount)} Likes </span>
                </span>
                <Link to={service.getRedirectUrl(`/quick-reads/${quickread.quickreadtype}/${service.replaceSymbols(quickread.title)}/${quickread.discussionId}`)} className="actioncount" data-count={quickread.commentCount}>
                    
                    <span className="L10_63 quickread_comments"> {service.intToString(quickread.commentCount)} Comments </span>
                </Link>

                <span className="M13_422 card-share quickread_participants" data-count={quickread.participantCount} /*onClick={() => actions.participantList(quickread.discussionId, quickread.participantCount)}*/>
                    <span className="L10_63"> {service.intToString(quickread.participantCount)} Share </span>
                </span>
            </div>
        </div>
    );
}
